import { render, staticRenderFns } from "./PersonBatchProfileDetails.vue?vue&type=template&id=fd9c3b86&scoped=true&"
import script from "./PersonBatchProfileDetails.vue?vue&type=script&lang=js&"
export * from "./PersonBatchProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonBatchProfileDetails.vue?vue&type=style&index=0&id=fd9c3b86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9c3b86",
  null
  
)

export default component.exports